'use client';

import type { Content } from '@prismicio/client';
import { screenSizes } from '@/constants';
import { DesktopMenu } from './DesktopMenu/DesktopMenu';
import { MobileMenu } from './MobileMenu/MobileMenu';
import { useMounted, useScreenSize } from '@/hooks';

export const HeaderMenu = ({ slice }: { slice: Content.NavigationSlice }) => {
  const size = useScreenSize();
  const isMounted = useMounted();

  if (!isMounted) {
    return null;
  }

  return size.width < screenSizes.desktop ? (
    <MobileMenu slice={slice} />
  ) : (
    <DesktopMenu slice={slice} />
  );
};
